export const DEFAULT_POLL_MS: number = 5000;
